export function axConvertString(x) {
    if (typeof x === 'string') {
        return x;
    }
    return x + '';
}
